import VoiceSlide from './VoiceSlide';

export default class {
  constructor() {

    const voiceSlideDom = document.querySelectorAll('[data-js="internship-voice-slide"]');
    voiceSlideDom.forEach(el => new VoiceSlide(el));

  }
}
